<template>
  <div class="row justify-content-center">
    <b-dropdown size="sm" variant="outline-secondary" v-if="languages && languages.length > 1" text="Select language" class="mt-3 ml-auto mr-3">
      <template #button-content>
        <b-icon-chat/>
      </template>
      <b-dropdown-item v-bind:key="item.id" v-for="item in languages" @click="() => changeLanguage(item.iso_code)">{{item.title}}</b-dropdown-item>
    </b-dropdown>
    <div class="col-12 text-center">
      <form-wizard
          v-if="wizardDisplay"
          ref="wizard"
          :title="settings['appointmentgroup.default.frontend.heading'].value"
          :subtitle="settings['appointmentgroup.default.frontend.subheading'].value"
          :back-button-text="settings['appointmentgroup.default.frontend.button.back'].value"
          :next-button-text="settings['appointmentgroup.default.frontend.button.next'].value"
          finish-button-text="Reservieren"
          color="#006eb8"
          @on-change="onTabChange">
        <tab-content v-if="wizardDisplayStep1" :title="settings['appointmentgroup.default.frontend.heading.tab1'].value" class="text-left" :before-change="validateSubsidiaryGroup">
          <div v-if="subsidiaries.length > 1">
            <b>{{settings['appointmentgroup.default.frontend.heading.subsidiaries'].value}}</b>
            <b-form-group class="mt-2">
              <b-form-radio v-for="subsidiary in subsidiaries" :key="subsidiary.id" @input="getGroups" v-model="selectedSubsidiary" name="subsidiary" :value="subsidiary">{{subsidiary.title}}</b-form-radio>
            </b-form-group>
          </div>

          <div v-if="(selectedSubsidiary && groups.length > 1) || groups.find(el => el.public_user_required)">
            <b>{{settings['appointmentgroup.default.frontend.heading.groups'].value}}</b>
            <b-form-group class="mt-2">
              <b-form-radio v-for="group in groups" :key="group.id" v-model="selectedGroup" name="group" :value="group">{{group.title}}</b-form-radio>

              <b-form-group v-if="selectedGroup && selectedGroup.public_user_required" class="w-75 d-block mt-3">
                <b-alert variant="info" show class="mt-2">{{settings['appointmentgroup.default.frontend.login.alert-info'].value}}</b-alert>
                <b-form-group :label="settings['appointmentgroup.default.frontend.login.username'].value" label-for="input-username" label-cols="3" label-cols-lg="2">
                  <b-form-input :placeholder="settings['appointmentgroup.default.frontend.login.username'].value" v-model="publicUser.username" id="input-username"/>
                </b-form-group>
                <b-form-group :label="settings['appointmentgroup.default.frontend.login.password'].value" label-for="input-password" label-cols="3" label-cols-lg="2">
                  <b-form-input :placeholder="settings['appointmentgroup.default.frontend.login.password'].value" type="password" class="mt-1" v-model="publicUser.password" id="input-password"/>
                </b-form-group>
                <b-button v-if="preform.length > 0" class="bg-primary mb-2" @click="login">{{settings['appointmentgroup.default.frontend.login.submit'].value}}</b-button>
                <b-alert :show="errorLoginPublicUser" variant="danger">{{errorLoginPublicUserText}}</b-alert>
              </b-form-group>
            </b-form-group>
          </div>

          <div v-if="(preform && selectedGroup && !selectedGroup.public_user_required) || (preform && selectedGroup && selectedGroup.public_user_required && loginUser.success && loginUser.groupId === selectedGroup.id)">
            <customer-form ref="customerPreFormModule"
                           :form="preform"
                           :is-pre-form="true"
                           :selected-group="selectedGroup"
                           :selected-subsidiary="selectedSubsidiary"
                           :settings="settings"
                           @group-filter-change="onGroupFilterChange"
            >
            </customer-form>
            <!--
            <div v-for="formelement in preform" :key="formelement.key">

              <b-row v-if="formelement.type === 'select'">
                <b-col cols="12" md="6">
                  <b-form-group
                      label-cols-sm="12"
                      label-cols-lg="12"
                      :name="formelement.key"
                      :label="formelement.label"
                      :state="formStates[formelement.key]"
                      invalid-feedback="Bitte wählen Sie eine Option"
                  >
                    <b-form-radio-group
                        v-model="userInput[formelement.key]"
                        :options="formelement.config.options"
                        @input="validateFormelement(formelement)"
                        value-field="content"
                        text-field="label"
                        stacked
                    ></b-form-radio-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                  <div v-if="userInput[formelement.key]" v-html="nl2br(userInput[formelement.key])"></div>
                </b-col>
              </b-row>

              </div>-->
          </div>
        </tab-content>
        <tab-content :title="settings['appointmentgroup.default.frontend.heading.tab2'].value" class="text-left" :before-change="validateStep2">
          <div v-if="selectedSubsidiary && selectedGroup && wizardReady && ((wizardDisplayStep1 && $refs.wizard.activeTabIndex >= 1) || (!wizardDisplayStep1 && $refs.wizard.activeTabIndex >= 0))">


            <appointments v-if="steps.step2 === 'appointments'"
                          ref="appointmentModule"
                          :selected-subsidiary="selectedSubsidiary"
                          :selected-group="selectedGroup"
                          :settings="settings"
                          :errors="errors"
                          :group-filter="groupFilterFromPreForm">
            </appointments>
            <customer-form v-if="steps.step2 === 'customerform'"
                           ref="customerFormModule"
                           :form="form"
                           :selected-date="selectedDate"
                           :selected-group="selectedGroup"
                           :selected-subsidiary="selectedSubsidiary"
                           :settings="settings"
                           @settings-override="onSettingsOverride"
                           @settings-restore="onSettingsRestore"
            >
            </customer-form>

          </div>
        </tab-content>
        <tab-content :title="settings['appointmentgroup.default.frontend.heading.tab3'].value" class="text-left" :before-change="validateStep3">

          <div v-if="selectedSubsidiary && selectedGroup && wizardReady && ((wizardDisplayStep1 && $refs.wizard.activeTabIndex >= 2) || (!wizardDisplayStep1 && $refs.wizard.activeTabIndex >= 1))">

            <appointments v-if="steps.step3 === 'appointments'"
                          ref="appointmentModule"
                          :selected-subsidiary="selectedSubsidiary"
                          :selected-group="selectedGroup"
                          :settings="settings"
                          :errors="errors"
                          :group-filter="groupFilterFromPreForm"
                          @date-change="onAppointmentModuleDateChange">
            </appointments>
            <customer-form  v-if="steps.step3 === 'customerform'"
                            ref="customerFormModule"
                            :form="form"
                            :selected-date="selectedDate"
                            :selected-group="selectedGroup"
                            :selected-subsidiary="selectedSubsidiary"
                            :settings="settings"
                            @settings-override="onSettingsOverride"
                            @settings-restore="onSettingsRestore"
            >
            </customer-form>

            <form-captcha
                ref="formCaptchaModule"
                v-if="selectedDate"
                :date="selectedDate"
                :form="form"
                :settings="settings">
            </form-captcha>

            <b-alert show variant="danger" v-if="errors.ERR_NO_TICKETS_LEFT">
              {{settings['appointmentgroup.default.frontend.message.no_tickets_left'].value}}
            </b-alert>

          </div>

        </tab-content>
        <tab-content :title="settings['appointmentgroup.default.frontend.heading.tab4'].value" class="text-left">

          <h4>{{settings['appointmentgroup.default.frontend.heading.message.success'].value}}</h4>
          <div class="form-html-content" v-html="settings['appointmentgroup.default.frontend.message.success'].value"></div>
          <br/><br/>
          <b-button @click="resetWizard">{{settings['appointmentgroup.default.frontend.button.new_appointment'].value}}</b-button>
          <b-button v-if="sendPdf" @click="downloadPdf" class="ml-2">{{settings['appointmentgroup.default.frontend.button.download.pdf'].value}}</b-button>
        </tab-content>

        <template slot="footer" slot-scope="props">
          <div class="wizard-footer-left">
            <wizard-button  v-if="props.activeTabIndex > 0 && !props.isLastStep" @click.native="props.prevTab()" :style="props.fillButtonStyle">{{settings['appointmentgroup.default.frontend.button.back'].value}}</wizard-button>
          </div>
          <div class="wizard-footer-right">
            <div v-if="wizardDisplayStep1">
              <wizard-button v-if="props.activeTabIndex < 2" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle">{{settings['appointmentgroup.default.frontend.button.next'].value}}</wizard-button>
              <wizard-button v-if="props.activeTabIndex == 2" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle">{{settings['appointmentgroup.default.frontend.button.submit'].value}}</wizard-button>
            </div>
            <div v-else>
              <wizard-button v-if="props.activeTabIndex < 1" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle">{{settings['appointmentgroup.default.frontend.button.next'].value}}</wizard-button>
              <wizard-button v-if="props.activeTabIndex == 1" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle">{{settings['appointmentgroup.default.frontend.button.submit'].value}}</wizard-button>
            </div>
          </div>
        </template>
      </form-wizard>
    </div>

  </div>

</template>

<script>

import Vue from 'vue'
import { BAlert, BButton, BDropdown, BDropdownItem, BFormGroup, BFormRadio, BIconChat, BFormInput } from 'bootstrap-vue'
import VueFormWizard from 'vue-form-wizard'
import axios from 'axios'
import VueAxios from 'vue-axios'
import CustomerForm from "./CustomerForm";
import Appointments from "./Appointments";
import FormCaptcha from "./FormCaptcha";
// import {  validateAll } from 'indicative/validator'
/* MOMENT */
const moment = require('moment')
moment.locale('de')

Vue.use(require('vue-moment'), {
  moment
})

Vue.use(VueFormWizard)

Vue.use(VueAxios, axios)
axios.defaults.baseURL = `${process.env.VUE_APP_API_URL}/api/v1`

export default {
  name: 'Home',
  components: {
    FormCaptcha,
    Appointments,
    CustomerForm,
    'b-button': BButton,
    'b-alert': BAlert,
    'b-form-group': BFormGroup,
    'b-form-radio': BFormRadio,
    'b-dropdown': BDropdown,
    'b-dropdown-item': BDropdownItem,
    'b-icon-chat': BIconChat,
    'b-form-input': BFormInput
  },
  data () {
    return {
      steps: {
        step2: process.env.VUE_APP_STEP2,
        step3: process.env.VUE_APP_STEP3
      },
      sendPdf: false,
      apiUrl: process.env.VUE_APP_API_URL + '/api/v1',
      languages: [],
      currentLanguage: '',
      errors: {},
      subsidiaries: [],
      groups: [],
      selectedSubsidiary:null,
      prevSelectedGroupId: null,
      selectedGroup:null,
      selectedDate:null,
      selectedDay:null,
      groupFilterFromPreForm: [],
      userInput: {},
      preform: [],
      form: [],
      formStates: {},
      formRules: {},
      formValidateCount: 0,
      minDate: '',
      maxDate: '',
      wizardDisplayStep1: true,
      wizardDisplay: false,
      wizardReady: false,
      formToken: null,
      settings:null,
      groupSettings:null,
      pdfDownloadLinkHref: null,
      pdfDownloadLinkAttributeValue: null,
      createdAppointmentId: null,
      createdTicketId: null,
      createdTicketAppointmentGroupId: null,
      urlQuery: {
        subsidiary_id: null,
        group_id: null
      },
      initialSettings: {
        offset_days_start: null
      },
      publicUser: {
        username: '',
        password: ''
      },
      errorLoginPublicUserText: '',
      errorLoginPublicUser: false,
      loginUser: {
        groupId: null,
        success: false
      }
    }
  },
  async mounted() {
    let uri = window.location.search
    let UrlParams = new URLSearchParams(uri)
    this.urlQuery.subsidiary_id = parseInt(UrlParams.get("subsidiary"));
    this.urlQuery.group_id= parseInt(UrlParams.get("group"));

    const result = await this.axios.get('subsidiaries')
    this.subsidiaries = result.data

    const settings = await this.axios.get('/settings?path=appointmentgroup.default.frontend.*')
    this.settings = settings.data.settings
    this.currentLanguage = settings.data.isoCode

    const languages = await this.axios.get('/languages/all')
    this.languages = languages.data
    const browserLanguage = navigator.language.split('-')[0]

    if(!isNaN(this.urlQuery.subsidiary_id) && this.urlQuery.subsidiary_id > 0) {
      for(let i = 0; i < this.subsidiaries.length; i++) {
        if(this.subsidiaries[i].id == this.urlQuery.subsidiary_id) {
          this.selectedSubsidiary = this.subsidiaries[i]
        }
      }
    }

    if(this.selectedSubsidiary !== null) {
      await this.getGroups()
    }
    else if(this.subsidiaries.length === 1) {
      this.selectedSubsidiary = this.subsidiaries[0]
      await this.getGroups()
    }
    else {
      this.wizardDisplay = true
      this.wizardReady = true
    }

    if(browserLanguage && browserLanguage !== 'de' && this.languages && this.languages.length > 0) {
      for(const lang of this.languages) {
        if(lang.iso_code == browserLanguage) {
          await this.changeLanguage(browserLanguage)
          break
        }
      }

    }

  },
  computed: {
  },
  watch: {
    selectedGroup: function() {
      this.onGroupChange()
    }
  },
  methods: {
    async login() {

      if(this.selectedGroup.public_user_required) {
        try {
          await this.axios.post('/public-users/login', {...this.publicUser, appointmentGroupId: this.selectedGroup.id})
          this.errorLoginPublicUser = false
          this.loginUser.success = true
          this.loginUser.groupId = this.selectedGroup.id
        } catch(e) {
          if (e.response.status === 401 || e.response.status === 404) {
            this.errorLoginPublicUserText = 'Ihre eingegebenen Zugangsdaten waren nicht korrekt'
            this.errorLoginPublicUser = true
          }
          if (e.response.status === 403) {
            this.errorLoginPublicUserText = 'Sie haben bereits die maximale Anzahl an Buchungen erreicht'
            this.errorLoginPublicUser = true
          }
          this.loginUser.success = false
        }
      }
    },
    onGroupFilterChange(filter) {
      this.groupFilterFromPreForm = filter
    },
    async changeLanguage(isoCode) {
      this.currentLanguage = isoCode
      const settings = await this.axios.get(`/settings?path=appointmentgroup.default.frontend.*&isocode=${isoCode}`)
      this.settings = settings.data.settings
      document.documentElement.setAttribute('lang', isoCode)
      if(this.selectedGroup) {
        await this.getForm()
      }
    },
    onSettingsOverride(setting) {
      if(setting.key === 'offset_days_start') {
        if(this.initialSettings[setting.key] === null) {
          this.initialSettings[setting.key] = this.selectedGroup.offset_days_start
        }
        this.selectedGroup.offset_days_start = parseInt(setting.value)
      }
    },
    onSettingsRestore(setting) {
      if(this.initialSettings[setting.key] === null) return
      if(setting.key === 'offset_days_start') {
        this.selectedGroup.offset_days_start = this.initialSettings[setting.key]
      }
    },
    async onTabChange(prevIndex, nextIndex) {
      const dateSelectViewIndex = this.wizardDisplayStep1 ? 1 : 0

      if(nextIndex === dateSelectViewIndex) { // Choose Date View

        if(this.errors.ERR_NO_TICKETS_LEFT) {
          // back from further left with no tickets left
          this.selectedDay = null
          this.selectedDate = null
        }

        // await this.getAvailableDates()

      }
    },
    async getGroups() {

      this.selectedGroup = null

      const result = await this.axios.get('appointment-groups/?subsidiary=' + this.selectedSubsidiary.id)
      this.groups = result.data

      if(!isNaN(this.urlQuery.group_id) && this.urlQuery.group_id > 0) {
        for(let i = 0; i < this.groups.length; i++) {
          if(this.groups[i].id == this.urlQuery.group_id) {
            this.selectedGroup = this.groups[i]
          }
        }
      }

      if(this.groups.length === 1 && !this.groups[0].public_user_required) {
        this.selectedGroup = this.groups[0]
      }

      await this.initWizard()

    },
    async initWizard() {
      if(!this.wizardReady && !this.groups.find(el => el.public_user_required) && ((this.subsidiaries.length === 1 && this.groups.length === 1) && this.selectedGroup !== null || (this.selectedSubsidiary !== null && this.selectedGroup !== null))) {
        await this.getForm()
        // remove step 1
        this.wizardDisplayStep1 = (this.preform.length > 0)
        await this.validateSubsidiaryGroup()
      }

      this.wizardDisplay = true

      Vue.nextTick(() => {
        this.wizardReady = true
      })

    },
    async getForm() {
      this.form = []

      const result = await this.axios.get('appointment-groups/' + this.selectedGroup.id + '/form/' + this.currentLanguage)

      this.form = []
      this.preform = []
      this.formToken = result.headers['x-form-token']
      if(this.$refs.customerFormModule) this.$refs.customerFormModule.reset()

      for(const formelement of result.data) {
        if(formelement.config.display_rules && Object.keys(formelement.config.display_rules).length > 0) {
          formelement.show = false
        } else {
          formelement.show = true
        }
        if(formelement.config.has_appointment_filter && formelement.config.has_appointment_filter == 'true') {
          this.preform.push(formelement)
        } else {
          this.form.push(formelement)
        }
      }

    },
    async validateSubsidiaryGroup() {
      if(this.selectedGroup.public_user_required && this.preform.length === 0) {
        try {
          await this.axios.post('/public-users/login', {...this.publicUser, appointmentGroupId: this.selectedGroup.id})
          this.errorLoginPublicUser = false
        } catch(e) {
          if (e.response.status === 401 || e.response.status === 404) {
            this.errorLoginPublicUserText = 'Ihre eingegebenen Zugangsdaten waren nicht korrekt'
            this.errorLoginPublicUser = true
          }
          if (e.response.status === 403) {
            this.errorLoginPublicUserText = 'Sie haben bereits die maximale Anzahl an Buchungen erreicht'
            this.errorLoginPublicUser = true
          }
          return false
        }
      }
      if(this.selectedGroup.public_user_required && this.preform.length > 0 && !this.loginUser.success) {
        return false;
      }
      // Before Change Step 2
      if (this.selectedGroup && this.selectedSubsidiary && this.selectedGroup.id > 0 && this.selectedSubsidiary.id > 0) {
        // await this.getForm()
        if(!this.wizardDisplayStep1) {
          // await this.getAvailableDates()
        }

        if(this.preform.length > 0 && this.$refs.customerPreFormModule) {
          return (this.$refs.customerPreFormModule.validate()).isValid
          /* for(const formelement of this.preform) {
            if(!this.validateFormelement(formelement)) return false
          } */
        }

        this.availableSlots = []
        this.selectedDay = null
        await this.overwriteGroupSettings()

        return true
      }

      return false
    },
    async overwriteGroupSettings() {
      const groupSettings = await this.axios.get(`/settings?path=appointmentgroup.${this.selectedGroup.id}.frontend.*&&isocode=${this.currentLanguage}`)
      const sendPdf = await this.axios.get(`/settings?path=appointmentgroup.${this.selectedGroup.id}.pdf.send`)

      this.groupSettings = groupSettings.data.settings
      this.sendPdf = !!(sendPdf.data[`appointmentgroup.${this.selectedGroup.id}.pdf.send`] && sendPdf.data[`appointmentgroup.${this.selectedGroup.id}.pdf.send`].value === 'true');

      for (let key in this.groupSettings) {
        const defaultKey = key.replace('.' + this.selectedGroup.id + '.', '.default.')
        if (this.settings[defaultKey]) {
          this.settings[defaultKey] = this.groupSettings[key]
        }
      }
    },
    onAppointmentModuleDateChange(date) {
      this.selectedDate = date
    },
    validateAppointmentModule() {
      const step2Result = this.$refs.appointmentModule.validate()
      if(step2Result.isValid) {
        this.selectedDate = step2Result.selectedDate
      }
      return step2Result.isValid
    },
    validateCustomerFormModule() {
      return (this.$refs.customerFormModule.validate()).isValid

    },
    validateStep2() {
      if(this.steps.step2 === 'appointments') {
        return this.validateAppointmentModule()
      }
      if(this.steps.step2 === 'customerform') {
        return this.validateCustomerFormModule()
      }

    },
    async validateStep3 () {

      let step3ModuleIsValid
      if(this.steps.step3 === 'appointments') {
        step3ModuleIsValid = this.validateAppointmentModule()
      }
      if(this.steps.step3 === 'customerform') {
        step3ModuleIsValid = this.validateCustomerFormModule()
      }

      const formCaptchaResult = this.$refs.formCaptchaModule.validate()
      let step3isValid = (step3ModuleIsValid && formCaptchaResult.isValid)

      if(step3isValid) {

        const customerFormResult = this.$refs.customerFormModule.validate()
        let userInput = customerFormResult.userInput

        if(this.preform.length > 0) {
          const customerPreFormResult = this.$refs.customerPreFormModule.validate()
          userInput = Object.assign(userInput, customerPreFormResult.userInput)
        }

        userInput.form_captcha = formCaptchaResult.userInput

        const postData = {
          appointment_id: this.selectedDate.id,
          form_values: userInput,
          isoCode: this.currentLanguage
        }
        if(this.selectedGroup.public_user_required) {
          postData.username = this.publicUser.username
          postData.password = this.publicUser.password
        }
        try {
          const createdAppointment = await this.axios.post('appointments/' + this.selectedDate.id + '/tickets', postData, {
            headers: {
              'X-Form-Token': this.formToken
            },
          })

          this.createdTicketId = createdAppointment.data.createdTicketId
          this.createdAppointmentId = createdAppointment.data.id
          this.createdTicketAppointmentGroupId = createdAppointment.data.appointmentGroupId

          this.$refs.customerFormModule.reset()
          this.form = {}
          this.prevSelectedGroupId = this.selectedGroup.id
          this.formToken = null
          this.selectedDate = null
          this.selectedDay = null
          this.selectedGroup = null

        } catch(e) {

          if(e.response.status !== 200) {

            step3isValid = false

            if(e.response.data.type === 'captcha') {

              this.$refs.formCaptchaModule.reset()
              this.formToken = e.response.headers['x-form-token']
              this.form.pop()
              this.form.push(e.response.data)

            }
            else {

              if(this.steps.step2 === 'customerform') {
                // set wizard to display step2 to see form errors
                this.$refs.wizard.changeTab(2,1)
              }

              this.$refs.customerFormModule.setErrors(e.response.data)

            }

            if(e.response.data === 'ERR_NO_TICKETS_LEFT') {
              // kein freier slot mehr frei
              this.errors.ERR_NO_TICKETS_LEFT = true
            }

            this.formValidateCount++

          }

        }

      }

      return step3isValid
    },
    async downloadPdf() {
      const pdf = await this.axios.post('/appointments/ticket-pdf', {
        appointmentGroupId: this.createdTicketAppointmentGroupId,
        ticketId: this.createdTicketId,
        appointmentId: this.createdAppointmentId
      }, { responseType: 'blob' })

      const url = window.URL.createObjectURL(new Blob([pdf.data]))
      const link = document.createElement('a')
      link.href = url

      link.setAttribute('download', pdf.headers['x-filename'])
      document.body.appendChild(link)
      link.click()
    },
    resetWizard () {
      this.$refs.wizard.reset()
      this.getGroups()
    },
    async onGroupChange () {
      this.form = []
      this.preform = []
      await this.getForm()
    }

  }
}
</script>
<style>
@import './../../node_modules/bootstrap/dist/css/bootstrap.css';
@import './../../node_modules/bootstrap-vue/dist/bootstrap-vue.css';
@import './../custom.css';
@import './../../node_modules/vue-form-wizard/dist/vue-form-wizard.min.css';
@import './../../node_modules/flatpickr/dist/flatpickr.css';

.flatpickr-input {
  display:none;
}
.flatpickr-wrapper {
  width:100%;
}
.form-html-content p {
  margin-bottom: 0;
}
</style>
